import { SET_SWITCH_SCHOOL,SET_SWITCH_SCHOOL_FALSE  } from "../actions/SwitchSchoolAction";

const initialState = {
  isSwitch: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SWITCH_SCHOOL:
      return {
        ...state,
        isSwitch: action.payload,
      };
   
    default:
      return state;
  }
};